const dict = {
  uk: {
    timerTitle: 'Таймер',
    timerActive: 'Таймер активний',
    timerStop: 'Зупинити таймер',
    timerPrompt: 'Оберіть час для вправи. Учні побачать відлік на екрані.',
    timerMinutesShort: 'хв',
    timerCustomLabel: 'Свій час (хвилини)',
    timerStart: 'Старт',
    ratingTitle: 'Оцініть урок',
    ratingSubtitle: 'Ваш відгук допоможе нам покращити якість навчання',
    ratingCommentLabel: "Коментар (необов'язково)",
    ratingCommentPlaceholder: 'Поділіться своїми враженнями...',
    ratingSkip: 'Пропустити',
    ratingSubmit: 'Надіслати відгук',
    chat: {
      unavailable: 'Чат недоступний',
      cantConnectClub: 'Не вдалося підключитися до групового чату',
      cantConnect: "Не вдалося встановити з'єднання для чату",
      clubGroup: 'Груповий чат клубу',
      lesson: 'Чат уроку',
      messagesWillAppear: "Повідомлення з'являться тут",
      inputPlaceholder: 'Повідомлення...',
    },
    report: {
      close: 'Закрити',
      title: 'Звіт про урок',
      subtitle: 'Допоможіть покращити якість платформи',
      qErrors: 'Чи були помилки в презентації?',
      allGood: 'Ні, все добре',
      yesErrors: 'Так, були',
      errorsPlaceholder: 'Опишіть помилки, які виникли...',
      qStudentLiked: 'Чи сподобався урок учню?',
      likedYes: 'Так',
      likedNo: 'Ні / Не впевнений',
      qEngagement: 'Оцініть залученість учня',
      engagementLow: 'Низька',
      engagementHigh: 'Висока',
      qTechIssues: 'Чи були технічні проблеми?',
      no: 'Ні',
      yes: 'Так',
      techPlaceholder: 'Опишіть технічні проблеми...',
      notesLabel: 'Додаткові нотатки (необов\'язково)',
      notesPlaceholder: 'Будь-які додаткові коментарі про урок...',
      submit: 'Надіслати звіт',
    },
    cameraPreview: {
      title: 'Перевірка камери та мікрофона',
      cameraError: 'Не вдалося отримати доступ до камери. Перевірте дозволи браузера.',
      tryAgain: 'Спробувати знову',
      cameraOff: 'Камера вимкнена',
      turnCameraOff: 'Вимкнути камеру',
      turnCameraOn: 'Увімкнути камеру',
      turnMicOff: 'Вимкнути мікрофон',
      turnMicOn: 'Увімкнути мікрофон',
      blurOn: 'Розмиття увімкнено',
      blurOff: 'Розмити фон',
      blurNotice: 'Розмиття фону буде застосовано під час уроку',
      lessonLabel: 'Урок:',
      cancel: 'Скасувати',
      enterLesson: 'Увійти на урок',
      lessonTypeClub: 'Заняття клубу',
      lessonTypeTrial: 'Пробний урок',
      lessonTypeGroup: 'Груповий урок',
      lessonTypeSpeaking: 'Speaking club',
      lessonTypeIndividual: 'Індивідуальний урок',
    },
  },
  en: {
    timerTitle: 'Timer',
    timerActive: 'Timer active',
    timerStop: 'Stop timer',
    timerPrompt: 'Choose a time for the exercise. Students will see the countdown on screen.',
    timerMinutesShort: 'min',
    timerCustomLabel: 'Custom time (minutes)',
    timerStart: 'Start',
    ratingTitle: 'Rate the lesson',
    ratingSubtitle: 'Your feedback helps us improve teaching quality',
    ratingCommentLabel: 'Comment (optional)',
    ratingCommentPlaceholder: 'Share your impressions...',
    ratingSkip: 'Skip',
    ratingSubmit: 'Submit feedback',
    chat: {
      unavailable: 'Chat unavailable',
      cantConnectClub: 'Could not connect to the group chat',
      cantConnect: 'Could not establish a chat connection',
      clubGroup: 'Club group chat',
      lesson: 'Lesson chat',
      messagesWillAppear: 'Messages will appear here',
      inputPlaceholder: 'Message...',
    },
    report: {
      close: 'Close',
      title: 'Lesson report',
      subtitle: 'Help us improve the platform',
      qErrors: 'Were there any errors in the presentation?',
      allGood: 'No, all good',
      yesErrors: 'Yes, there were',
      errorsPlaceholder: 'Describe the errors that occurred...',
      qStudentLiked: 'Did the student enjoy the lesson?',
      likedYes: 'Yes',
      likedNo: 'No / Not sure',
      qEngagement: 'Rate the student\'s engagement',
      engagementLow: 'Low',
      engagementHigh: 'High',
      qTechIssues: 'Were there any technical issues?',
      no: 'No',
      yes: 'Yes',
      techPlaceholder: 'Describe the technical issues...',
      notesLabel: 'Additional notes (optional)',
      notesPlaceholder: 'Any extra comments about the lesson...',
      submit: 'Submit report',
    },
    cameraPreview: {
      title: 'Check camera and microphone',
      cameraError: 'Could not access the camera. Check your browser permissions.',
      tryAgain: 'Try again',
      cameraOff: 'Camera off',
      turnCameraOff: 'Turn camera off',
      turnCameraOn: 'Turn camera on',
      turnMicOff: 'Mute microphone',
      turnMicOn: 'Unmute microphone',
      blurOn: 'Blur enabled',
      blurOff: 'Blur background',
      blurNotice: 'Background blur will be applied during the lesson',
      lessonLabel: 'Lesson:',
      cancel: 'Cancel',
      enterLesson: 'Enter lesson',
      lessonTypeClub: 'Club session',
      lessonTypeTrial: 'Trial lesson',
      lessonTypeGroup: 'Group lesson',
      lessonTypeSpeaking: 'Speaking club',
      lessonTypeIndividual: 'Individual lesson',
    },
  },
};

export default dict;
